
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CreateLegalAgreementDraftRequest,
  LegalAgreementContentResponse,
  LegalAgreementLanguage,
  LegalAgreementResource,
  LegalAgreementType,
  LegalAgreementVersionResource,
  ReplaceLegalAgreementDraftContentRequest,
  ValidationError,
} from '../models';
import {
    CreateLegalAgreementDraftRequestFromJSON,
    CreateLegalAgreementDraftRequestToJSON,
    LegalAgreementContentResponseFromJSON,
    LegalAgreementContentResponseToJSON,
    LegalAgreementLanguageFromJSON,
    LegalAgreementLanguageToJSON,
    LegalAgreementResourceFromJSON,
    LegalAgreementResourceToJSON,
    LegalAgreementTypeFromJSON,
    LegalAgreementTypeToJSON,
    LegalAgreementVersionResourceFromJSON,
    LegalAgreementVersionResourceToJSON,
    ReplaceLegalAgreementDraftContentRequestFromJSON,
    ReplaceLegalAgreementDraftContentRequestToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface CreateLegalAgreementDraftOperationRequest {
    agreementType: LegalAgreementType;
    createLegalAgreementDraftRequest: CreateLegalAgreementDraftRequest;
}

export interface GetLegalAgreementRequest {
    agreementType: LegalAgreementType;
}

export interface GetLegalAgreementVersionContentRequest {
    agreementType: LegalAgreementType;
    versionId: string;
    language: LegalAgreementLanguage;
}

export interface PublishLegalAgreementRequest {
    agreementType: LegalAgreementType;
}

export interface ReplaceLegalAgreementDraftContentOperationRequest {
    agreementType: LegalAgreementType;
    replaceLegalAgreementDraftContentRequest: ReplaceLegalAgreementDraftContentRequest;
}

/**
 * 
 */
export class LegalAgreementAdminApi extends runtime.BaseAPI {

    /**
     * Creates the draft content set for this agreement type. This endpoint returns validation errors if a draft already exists. 
     * Create a legal agreement draft
          */
    async createLegalAgreementDraftRaw(requestParameters: CreateLegalAgreementDraftOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<LegalAgreementResource>> {
        if (requestParameters['agreementType'] == null) {
            throw new runtime.RequiredError(
                'agreementType',
                'Required parameter "agreementType" was null or undefined when calling createLegalAgreementDraft().'
            );
        }

        if (requestParameters['createLegalAgreementDraftRequest'] == null) {
            throw new runtime.RequiredError(
                'createLegalAgreementDraftRequest',
                'Required parameter "createLegalAgreementDraftRequest" was null or undefined when calling createLegalAgreementDraft().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<LegalAgreementResource>({
            path: `/compliance/api/admin/legal-agreements/{agreementType}/draft`.replace(`{${"agreementType"}}`, encodeURIComponent(String(requestParameters['agreementType']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLegalAgreementDraftRequestToJSON(requestParameters['createLegalAgreementDraftRequest']),
        }, initOverrides);

        if (response._data) { response._data=LegalAgreementResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Creates the draft content set for this agreement type. This endpoint returns validation errors if a draft already exists. 
     * Create a legal agreement draft
          */
    async createLegalAgreementDraft(requestParameters: CreateLegalAgreementDraftOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<LegalAgreementResource> {
        const response = await this.createLegalAgreementDraftRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Retrieve legal agreement draft and published versions
          */
    async getLegalAgreementRaw(requestParameters: GetLegalAgreementRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<LegalAgreementResource>> {
        if (requestParameters['agreementType'] == null) {
            throw new runtime.RequiredError(
                'agreementType',
                'Required parameter "agreementType" was null or undefined when calling getLegalAgreement().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<LegalAgreementResource>({
            path: `/compliance/api/admin/legal-agreements/{agreementType}`.replace(`{${"agreementType"}}`, encodeURIComponent(String(requestParameters['agreementType']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=LegalAgreementResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Retrieve legal agreement draft and published versions
          */
    async getLegalAgreement(requestParameters: GetLegalAgreementRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<LegalAgreementResource> {
        const response = await this.getLegalAgreementRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Retrieves immutable published HTML content for a legal agreement version in the requested language. This endpoint is used by the admin PDF preview route. If content is not available in the requested language, it falls back to English. 
     * Get legal agreement published version content by agreement type, version id and language
          */
    async getLegalAgreementVersionContentRaw(requestParameters: GetLegalAgreementVersionContentRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<LegalAgreementContentResponse>> {
        if (requestParameters['agreementType'] == null) {
            throw new runtime.RequiredError(
                'agreementType',
                'Required parameter "agreementType" was null or undefined when calling getLegalAgreementVersionContent().'
            );
        }

        if (requestParameters['versionId'] == null) {
            throw new runtime.RequiredError(
                'versionId',
                'Required parameter "versionId" was null or undefined when calling getLegalAgreementVersionContent().'
            );
        }

        if (requestParameters['language'] == null) {
            throw new runtime.RequiredError(
                'language',
                'Required parameter "language" was null or undefined when calling getLegalAgreementVersionContent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<LegalAgreementContentResponse>({
            path: `/compliance/api/admin/legal-agreements/{agreementType}/versions/{versionId}/contents/{language}`.replace(`{${"agreementType"}}`, encodeURIComponent(String(requestParameters['agreementType']))).replace(`{${"versionId"}}`, encodeURIComponent(String(requestParameters['versionId']))).replace(`{${"language"}}`, encodeURIComponent(String(requestParameters['language']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=LegalAgreementContentResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Retrieves immutable published HTML content for a legal agreement version in the requested language. This endpoint is used by the admin PDF preview route. If content is not available in the requested language, it falls back to English. 
     * Get legal agreement published version content by agreement type, version id and language
          */
    async getLegalAgreementVersionContent(requestParameters: GetLegalAgreementVersionContentRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<LegalAgreementContentResponse> {
        const response = await this.getLegalAgreementVersionContentRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Publish legal agreement draft content
          */
    async publishLegalAgreementRaw(requestParameters: PublishLegalAgreementRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<LegalAgreementVersionResource>> {
        if (requestParameters['agreementType'] == null) {
            throw new runtime.RequiredError(
                'agreementType',
                'Required parameter "agreementType" was null or undefined when calling publishLegalAgreement().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<LegalAgreementVersionResource>({
            path: `/compliance/api/admin/legal-agreements/{agreementType}/publish`.replace(`{${"agreementType"}}`, encodeURIComponent(String(requestParameters['agreementType']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=LegalAgreementVersionResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Publish legal agreement draft content
          */
    async publishLegalAgreement(requestParameters: PublishLegalAgreementRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<LegalAgreementVersionResource> {
        const response = await this.publishLegalAgreementRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Replaces the full draft content set for this agreement type. Missing language keys remove existing draft content for these languages. 
     * Replace legal agreement draft content
          */
    async replaceLegalAgreementDraftContentRaw(requestParameters: ReplaceLegalAgreementDraftContentOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['agreementType'] == null) {
            throw new runtime.RequiredError(
                'agreementType',
                'Required parameter "agreementType" was null or undefined when calling replaceLegalAgreementDraftContent().'
            );
        }

        if (requestParameters['replaceLegalAgreementDraftContentRequest'] == null) {
            throw new runtime.RequiredError(
                'replaceLegalAgreementDraftContentRequest',
                'Required parameter "replaceLegalAgreementDraftContentRequest" was null or undefined when calling replaceLegalAgreementDraftContent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/admin/legal-agreements/{agreementType}/draft-content`.replace(`{${"agreementType"}}`, encodeURIComponent(String(requestParameters['agreementType']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ReplaceLegalAgreementDraftContentRequestToJSON(requestParameters['replaceLegalAgreementDraftContentRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Replaces the full draft content set for this agreement type. Missing language keys remove existing draft content for these languages. 
     * Replace legal agreement draft content
          */
    async replaceLegalAgreementDraftContent(requestParameters: ReplaceLegalAgreementDraftContentOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.replaceLegalAgreementDraftContentRaw(requestParameters, initOverrides);
    }

}
